import locale from "@packs/locale/locale"

export default function GroupTypeSelect(opts={}){
    BaseConstructor.call(this)
    let {container} = opts
    let elements = {}
    let context = this
    let current_select = 'coleta'

    this.generate = () =>{
        
    }

    this.update = () =>{

    }

    this.getCurrentState = _ =>{
        return current_select
    }

    this.getElement = _ =>{
        return elements.container
    }

    const generateOptions = _ =>{
        let options = ['minute','hour', 'day', 'month']

        options.forEach(option=>{
            $(elements.select).append('<option value="'+option+'">'+locale.t(option)+'</option>')
        })
    }

    init()

    function init(){
        elements.container = context.createElement('div')
        elements.select_container = context.createElement('div')
        elements.select = context.createElement('select')
        $(elements.select_container).append(elements.select)
        
        generateOptions()

        $(elements.select).on('change',event=>{
            context.trigger('change', {previous: current_select, new:event.target.value})
        })
        
        $(elements.container).append(elements.select_container)
        
    }
}

GroupTypeSelect.prototype = Object.create(BaseConstructor.prototype)